import styled, {css, keyframes} from 'styled-components'
import {Box, themeGet} from '../..'
import Dialog from '../Dialog2'

const overlayShow = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const StyledDialogOverlay = styled(Dialog.Overlay)`
  background-color: ${themeGet('colors.blanket.default')};
  position: fixed;
  inset: 0;
  animation: ${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);
`

export const contentShow = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`
export const StyledDialogBox = styled(Dialog.Content)<{size: string}>`
  ${props => {
    switch (props.size) {
      case 'sm':
        return css`
          width: 400px;
        `
      case 'md':
        return css`
          width: 600px;
        `
      case 'lg':
        return css`
          width: 752px;
        `
      case 'xl':
        return css`
          width: 968px;
        `
      default:
        return css`
          width: 400px;
        `
    }
  }}
  background-color: ${themeGet('colors.elevation.surface.default.[default]')};
  border-radius: ${themeGet('radii.1')};
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90vw;
  padding: ${themeGet('space.4')};
  animation: ${contentShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);
  &:focus {
    outline: none;
  }
`
export const StyledAlertDialogHeader = styled(Dialog.Title)`
  margin: 0;
  margin-bottom: ${themeGet('space.3')};
  font-weight: ${themeGet('fontWeights.semibold')};
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.6')};
  display: flex;
  gap: ${themeGet('space.1')};
`
export const StyledAlertDialogBody = styled(Dialog.Description)`
  margin: ${themeGet('space.2')} 0;
  color: ${themeGet('colors.text.subtle')};
  font-size: ${themeGet('fontSizes.3')};
  line-height: ${themeGet('lineHeights.default')};
  overflow: auto;
  max-height: 60vh;
`
export const StyledAlertDialogFooter = styled(Box)`
  display: flex;
  margin-top: ${themeGet('space.3')};
  gap: ${themeGet('space.2')};
  justify-content: flex-end;
`
